import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface AccountInfoState {
  username: string;
  fullname: string;
  type: string;
  roles: {
    admin: Boolean;
    checker: Boolean;
  };
  isCreatedOrder: Boolean;
  fullname_kana: string;
  email: string;
  phone_number: string;
  address: string;
  postal_code: string;
}

const initialState: AccountInfoState = {
  username: "",
  fullname: "",
  type: "",
  roles: {
    admin: false,
    checker: false,
  },
  isCreatedOrder: false,
  fullname_kana: "",
  email: "",
  phone_number: "",
  address: "",
  postal_code: "",
};

export const accountInfoSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setAccount: (state, action: PayloadAction<Partial<AccountInfoState>>) => {
      state.username = action.payload.username ?? "";
      state.fullname = action.payload.fullname ?? "";
      state.type = action.payload.type ?? "";
      state.roles.admin = action.payload.roles?.admin ?? false;
      state.roles.checker = action.payload.roles?.checker ?? false;
      if (action.payload.type === "customer") {
        state.fullname_kana = action.payload.fullname_kana ?? "";
        state.email = action.payload.email ?? "";
        state.phone_number = action.payload.phone_number ?? "";
        state.address = action.payload.address ?? "";
        state.postal_code = action.payload.postal_code ?? "";
      }
    },
    clearAccount: () => {
      return { ...initialState };
    },
    setIsCreatedOrder: (state, action: PayloadAction<boolean>) => {
      state.isCreatedOrder = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAccount, clearAccount, setIsCreatedOrder } =
  accountInfoSlice.actions;

export const getAccountInfo = (state: AccountInfoState) => state;

export default accountInfoSlice.reducer;
